import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["simpleTab", "advancedTab", "simplePanel", "advancedPanel", "modeField"]
  static values = { mode: { type: String, default: "simple" } }

  showSimple() {
    this.modeValue = "simple"
  }

  showAdvanced() {
    this.modeValue = "advanced"
  }

  modeValueChanged(value) {
    this.setMode(value)
  }

  setMode(mode) {
    if (this._activeMode === mode) return
    this._activeMode = mode
    const isSimple = mode === "simple"
    this.simplePanelTarget.disabled = !isSimple
    this.simplePanelTarget.classList.toggle("d-none", !isSimple)
    this.advancedPanelTarget.disabled = isSimple
    this.advancedPanelTarget.classList.toggle("d-none", isSimple)
    this.simpleTabTarget.classList.toggle("active", isSimple)
    this.advancedTabTarget.classList.toggle("active", !isSimple)
    this.modeFieldTarget.value = mode
  }
}
